import { Component } from '@angular/core';

@Component({
  selector: 'tt-material-grades-view',
  templateUrl: './material-grades-view.component.html',
  styleUrls: ['./material-grades-view.component.css']
})
export class MaterialGradesViewComponent {

}
